import { createFileRoute } from "@tanstack/react-router";

import DeleteAccountPage from "./-components/DeleteAccountPage";

export const Route = createFileRoute("/_app/_dashboard/profile/deleteaccount/")(
  {
    component: DeleteAccountPage,
  }
);
